import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";
import moment from "moment";

const CustomDatePicker = (props) => {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear - 100; i <= 2040; i++) {
    years.push(i);
  }

  const handleChangeWithIndex = (date) => {
    const validDate = date instanceof Date && !isNaN(date) ? date : new Date();
    props.handleChangeWithIndex(
      moment(validDate).format("DD-MMM-YYYY"),
      "datepicker",
      props.module,
      props.index,
      props.name
    );
  };

  return (
    <DatePicker
      customInput={<InputMask mask="99-aaa-9999" type="text" />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => {
        // Ensure date is a valid Date object
        const validDate = date instanceof Date && !isNaN(date) ? date : new Date();

        return (
          <div className="input-group input-group-sm input-group-calendar">
            <div className="input-group-prepend">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  decreaseMonth();
                }}
                disabled={prevMonthButtonDisabled}
                className="btn btn-outline-secondary"
                type="button"
              >
                {"<"}
              </button>
            </div>

            <select
              className="form-control"
              value={validDate.getFullYear()} // Fixed: Ensure a valid year is passed
              onChange={({ target: { value } }) => changeYear(Number(value))}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <select
              className="form-control"
              value={months[validDate.getMonth()]} // Fixed: Ensure a valid month is passed
              onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>

            <div className="input-group-append">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  increaseMonth();
                }}
                className="btn btn-outline-secondary"
                disabled={nextMonthButtonDisabled}
              >
                {">"}
              </button>
            </div>
          </div>
        );
      }}
      wrapperClassName={props.wrapperClassName}
      className="form-control"
      selected={props.selected}
      autoComplete="off"
      showIcon
      placeholderText={props.placeholderText}
      maxDate={props.maxDate}
      minDate={props.minDate}
      id={props.id}
      name={props.name}
      onChange={(date) => handleChangeWithIndex(date)}
      icon="fa fa-calendar"
      value={props.value}
    />
  );
};

export default CustomDatePicker;
